<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Cadastrar tópico
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="name"
            :rules="rulesName"
            :error-messages="formError.name"
            label="Nome do tópico"
            @input="formError.name = ''"
          />

          <v-select
            v-model="teachingSystem"
            :items="teachingSystems"
            :rules="teachingSystemsRules"
            item-text="name"
            item-value="id"
            label="Sistema de Ensino"
            @change="getVolumes"
          />

          <v-select
            v-model="subject"
            :items="subjects"
            :rules="rulesSubject"
            item-text="name"
            item-value="id"
            label="Matéria"
          />

          <v-select
            v-model="volume"
            :items="volumes"
            item-text="name"
            item-value="id"
            label="Volume"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { listTypes as listVolumeTypes } from '@/enums/volumeTypes'
export default {
  props: {
    subjects: { type: Array, default: () => [] },
    teachingSystems: { type: Array, default: () => [] }
  },

  data: () => ({
    rulesName: [
      value => !!value || 'Peencha este campo.'
    ],
    rulesSubject: [
      value => !!value || 'Peencha este campo.'
    ],
    teachingSystemsRules: [
      value => !!value || 'Peencha este campo.'
    ],
    formError: {},
    name: '',
    subject: '',
    teachingSystem: null,
    volumes: [],
    volume: null,
    id: null
  }),

  created () {
  },
  methods: {
    listVolumeTypes,
    validate () {
      return this.$refs.form.validate()
    },

    async getVolumes () {
      try {
        // this.volumes = await this.$api.getVolumes(this.$route.params.id, this.teachingSystem)
        this.volumes = await this.$api.getVolumes(this.$route.params.id, this.teachingSystem)
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter volumes, tente novamente mais tarde.', color: 'red' })
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      const data = {
        name: this.name,
        subject_id: this.subject,
        teaching_system_id: this.teachingSystem,
        volume_id: this.volume
      }
      this.$emit('resolve', data)
    }
  }
}
</script>
